<template>
  <div>
    <one-data-column>
      <data-heading
        slot="label"
        heading="Recipient"
      />
    </one-data-column>

    <one-data-column>
      <data-label slot="label">Recipient</data-label>
      <div class="t-recipient-name">{{ requisites.recipientName }}</div>
    </one-data-column>

    <one-data-column>
      <data-label slot="label">Registration</data-label>
      <div class="t-recipient-reg">{{ requisites.recipientRegNumber }}</div>
    </one-data-column>

    <one-data-column>
      <data-label slot="label">Address</data-label>
      <div class="t-recipient-address">{{ requisites.recipientAddress }}</div>
    </one-data-column>

    <one-data-column>
      <data-label slot="label">Country</data-label>
      <div class="t-recipient-country">{{ requisites.recipientCountry }}</div>
    </one-data-column>

    <one-data-column>
      <data-label slot="label">Bank name</data-label>
      <div class="t-bank-name">{{ requisites.bankName }}</div>
    </one-data-column>

    <one-data-column v-if="requisites.isTypeFps">
      <data-label slot="label">Sort code</data-label>
      <div class="t-sort-code">{{ requisites.sortCode }}</div>
    </one-data-column>

    <one-data-column v-if="requisites.isTypeFps">
      <data-label slot="label">Account number</data-label>
      <div class="t-account-number">{{ requisites.localAccountNumber }}</div>
    </one-data-column>

    <one-data-column>
      <data-label slot="label">IBAN</data-label>
      <div class="t-bank-account">{{ requisites.accountNumber | iban }}</div>
    </one-data-column>

    <one-data-column>
      <data-label slot="label">SWIFT code</data-label>
      <div class="t-bank-swift">{{ requisites.bankSwift }}</div>
    </one-data-column>

    <one-data-column v-if="requisites.bic">
      <data-label slot="label">BIC code</data-label>
      <div class="t-bank-bic">{{ requisites.bic }}</div>
    </one-data-column>

    <one-data-column v-if="requisites.inn">
      <data-label slot="label">INN</data-label>
      <div class="t-bank-inn">{{ requisites.inn }}</div>
    </one-data-column>

    <one-data-column>
      <data-label slot="label">Bank address</data-label>
      <div class="t-bank-address">{{ requisites.bankAddress }}</div>
    </one-data-column>

    <one-data-column>
      <data-label slot="label">Bank country</data-label>
      <div class="t-bank-country">{{ requisites.bankCountry }}</div>
    </one-data-column>

    <template v-if="requisites.correspondentBank">
      <one-data-column>
        <data-heading
          slot="label"
          heading="Correspondent bank"
        />
      </one-data-column>

      <one-data-column>
        <data-label slot="label">Bank name</data-label>
        <div class="t-correspondent-bank-name">{{ requisites.correspondentBank.bankName }}</div>
      </one-data-column>

      <one-data-column v-if="requisites.correspondentBank.accountNumber">
        <data-label slot="label">IBAN</data-label>
        <div class="t-correspondent-bank-account">{{ requisites.correspondentBank.accountNumber | iban }}</div>
      </one-data-column>

      <one-data-column>
        <data-label slot="label">SWIFT code</data-label>
        <div class="t-correspondent-bank-swift">{{ requisites.correspondentBank.swiftCode }}</div>
      </one-data-column>

      <one-data-column v-if="requisites.correspondentBank.address">
        <data-label slot="label">Bank address</data-label>
        <div class="t-correspondent-bank-address">{{ requisites.correspondentBank.address }}</div>
      </one-data-column>

      <one-data-column v-if="requisites.correspondentBank.country">
        <data-label slot="label">Bank country</data-label>
        <div class="t-correspondent-bank-country">{{ requisites.correspondentBank.country }}</div>
      </one-data-column>
    </template>

    <template v-if="intermediateBank">
      <one-data-column>
        <data-heading
          slot="label"
          heading="Intermediate bank"
        />
      </one-data-column>

      <one-data-column>
        <data-label slot="label">Bank name</data-label>
        <div class="t-bank-name">{{ intermediateBank.bankName }}</div>
      </one-data-column>

      <one-data-column v-if="intermediateBank.accountNumber">
        <data-label slot="label">Account No.</data-label>
        <div class="t-account-number">{{ intermediateBank.accountNumber }}</div>
      </one-data-column>

      <one-data-column v-if="intermediateBank.swiftCode">
        <data-label slot="label">SWIFT code</data-label>
        <div class="t-bank-swift">{{ intermediateBank.swiftCode }}</div>
      </one-data-column>

      <one-data-column v-if="intermediateBank.bicCode">
        <data-label slot="label">BIC code</data-label>
        <div class="t-bank-swift">{{ intermediateBank.bicCode }}</div>
      </one-data-column>
    </template>
  </div>
</template>

<script>
  // Models
  import Requisites from '@/models/Requisites'

  // Components
  import DataLabel from '@/components/ui/Data/DataLabel'
  import DataHeading from '@/components/ui/Data/DataHeading'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'

  export default {
    components: {
      DataLabel,
      DataHeading,
      OneDataColumn
    },
    props: {
      requisites: {
        required: true,
        type: Requisites
      },
      country: {
        type: String,
        default: null
      }
    },
    computed: {
      intermediateBank () {
        if (this.requisites.intermediateBank != null) {
          return this.requisites.intermediateBank[this.country]
        }
      }
    }
  }
</script>
